import axios from "axios";
import { IDashboardData } from "../model/dashboard.model";

export class DashboardService {
    private static rootUrl = '/dashboard';
    private static client = axios;

    static async getDashboard(): Promise<IDashboardData> {
        const response = await this.client.get<IDashboardData>(this.rootUrl);
        return response.data; 
    }
}
